const binding = { modules: {}, dataActions: {} };

    (binding.modules['splash-page'] = {
        c: () => require('partner/modules/splash-page/splash-page.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'splash-page',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/splash-page'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|splash-page|splash-page'] = {
                c: () => require('partner/modules/splash-page/splash-page.view.tsx'),
                cn: '__local__-__local__-splash-page'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };